module.exports = __webpack_public_path__ + "img/roadmap_image.10e00248.png";